import { useSlice } from "./useSlice";

export function useTestMode() {
  const { applicationLayer } = useSlice("config") || {};
  const isTestMode = applicationLayer === "test";
  return isTestMode;
}
